import styled from "styled-components";
import { media } from "../../theme/theme";
import { Body, H1 } from "../../components/Typography";

export const EmbedProfileWrapper = styled.div<{ $maxWidth?: string }>`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    max-width: ${({ $maxWidth }) => $maxWidth ? `${$maxWidth}px` : "1200px"};
    margin: 0 auto;
    padding: 0 15px;
`;

export const EmbedMasonCardWrapper = styled.div`
    border: 1px solid #DDDFE3;
    border-radius: 18px;
    overflow: hidden;
`;

export const MarketingLinksGallery = styled.div`
    padding: 0 15px;
    max-width: 900px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    > div {
        width: calc(50% - 9px);
        margin-bottom: 18px;

        ${media.custom(720)} {
            width: calc(33.3% - 12px);
        }
    }
`;

export const ExampleMidPageTextWrapper = styled.div`
    text-align: center;
`;

export const FixedLinkWrapper = styled.div`
    max-width: 650px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    
    > * {
        margin-right: 18px;
        margin-bottom: 18px;
    }
`;

export const ExampleLayoutDescription = styled.div`
    max-width: 750px;
    width: 100%;
    text-align: center;
    margin: 0 auto;
    
    ${H1} {
        margin-bottom: 30px;
        ${media.tablet} {
            margin-bottom: 40px;
        }
    }
    ${Body} {
        color: ${({ theme, color }) => color ? color : `${theme.marketing.colors.blackPearl80}`};
        margin: 0 auto 45px;
        max-width: 750px;
        ${media.tablet} {
            margin: 0 auto;
        }
    }
`;